<template>
  <div class="header">
    <img class="icon" :src="iconPath" :alt="name" />
    <div class="content">
      <div class="name">{{ name }}</div>
      <div v-if="desc" class="desc">{{ desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    iconPath: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    desc: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/common";
.header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 30px;
  .icon {
    width: 60px;
    height: 60px;
    user-select: none;
    pointer-events: none;
  }
  .content {
    .name {
      color: $color-text-primary;
      font-weight: 600;
      font-size: 24px;
      line-height: 42px;
    }
    .desc {
      color: $color-text-secondary;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>
